import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import { useAppDispatch, RootState } from "../../redux/store";
import EUCRMBanner from "./components/eucrm-banner";
import { useDynamicScripts } from "../../hooks/useDynamicScript";
import LoadingComp from "../../components/re-usable/loading/loading";
import PageNotFound from "../errors/page-not-found";
import RegisterAccordion from "../../components/re-usable/accordion/register.conference"
import ScheduleAccordion from "../../components/re-usable/accordion/schedule.conference"

const EUCRMIndex = () => {
  const { "*": urlPath } = useParams();
  const formattedPath = urlPath?.replaceAll("/", "%2F");

  const path = `%2FEUCRPS%2F${formattedPath}`;

  const dispatch = useAppDispatch();
  const { RapsEuropeData, RapsEuropeLoading: pageMenuLoading, pageNotFound } = useSelector((state: RootState) => state.rapsEurope);

  const [isPublished, setIsPublished] = useState(false);
  const [isPageNotFound, setIsPageNotFound] = useState(!pageMenuLoading && pageNotFound);
  const [scriptHtmlString, setScriptHtmlString] = useState("");

  useEffect(() => {
    dispatch(retrievePageMenu(path));
  }, [dispatch]);

  useEffect(() => {
    if (RapsEuropeData[0]?.result) {
      setIsPublished(true);
    }
    else if (!pageMenuLoading && pageNotFound) {
      setIsPageNotFound(true);
    }
  }, [RapsEuropeData]);

  useEffect(() => {
    if (isPublished) {
      if (RapsEuropeData[0].result[0]?.javaScriptField)
        setScriptHtmlString(RapsEuropeData[0].result[0]?.javaScriptField);
    }
    if (typeof window !== "undefined" && window.runGlobalScripts) {
      window.runGlobalScripts();
    }
  }, [isPublished])

  useDynamicScripts({ htmlScriptString: scriptHtmlString });

  if (isPageNotFound) return <PageNotFound />;
  if (!isPublished) return <LoadingComp />;

  return (
    <>
      <Helmet>
        <title>{RapsEuropeData[0]?.result[0]?.menuItemName}</title>
      </Helmet>
      <EUCRMBanner
        bannerImage={RapsEuropeData[0]?.result[0]?.mainHeaderImage}
        mobileBanner={RapsEuropeData[0]?.result[0]?.mobileHeaderImage}
        headerText={RapsEuropeData[0]?.result[0]?.headerText}
        topCommonMesage={RapsEuropeData[0]?.result[0]?.topCommonMesage}
      />
      <div dangerouslySetInnerHTML={{ __html: RapsEuropeData[0]?.result[0]?.description }}></div>
      {path.toLowerCase().indexOf('register') > 0 ? <RegisterAccordion path={path} /> : ""}
      {path.toLowerCase().indexOf('schedule') > 0 ? <ScheduleAccordion path={path} /> : ""}
      <div dangerouslySetInnerHTML={{ __html: RapsEuropeData[0]?.result[0]?.councilDescription }}></div>
      <div dangerouslySetInnerHTML={{ __html: RapsEuropeData[0]?.result[0]?.popupContent }}></div>
      <EUCRMStyles />
    </>
  );
};


const EUCRMStyles = () => {
  return (
    <>
      <style>
        {`
        `}
      </style>
    </>
  );
};

export default EUCRMIndex;
